module.exports = __webpack_public_path__ + "static/img/slogan.31f8c80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slogan.png
// module id = OwT5
// module chunks = 0